import React, { useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { FaUser, FaHome, FaTruck, FaBook, FaChartBar, FaUsers, FaSignInAlt, FaSignOutAlt, FaCog } from 'react-icons/fa';
import './Navbar.scss';
import { useAuth } from '../context/AuthContext';

const NavBar = () => {
  const { isAuthenticated, userPermissions } = useAuth();
  const navBarRef = useRef(null);
  const location = useLocation();

  const handleClickOutside = (event) => {
    if (navBarRef.current && !navBarRef.current.contains(event.target)) {
      const navbarToggler = document.querySelector('.navbar-toggler');
      const navbarCollapse = document.querySelector('.navbar-collapse');
      if (navbarCollapse.classList.contains('show')) {
        navbarToggler.click();
      }
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const navbarToggler = document.querySelector('.navbar-toggler');
    const navbarCollapse = document.querySelector('.navbar-collapse');
    if (navbarCollapse.classList.contains('show')) {
      navbarToggler.click();
    }
  }, [location]);

  const hasManageUsersPermission = userPermissions.includes('Manage Users');

  return (
    <Navbar expand="lg" className="navbar" ref={navBarRef}>
      <div className="container-fluid">
        <Navbar.Brand as={Link} to="/" className="navbar-brand">
          {process.env.REACT_APP_SITE_NAME}
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ml-auto">
            <Nav.Link as={Link} to="/"><FaHome className="nav-icon" /> Home</Nav.Link>
            <Nav.Link as={Link} to="/provider"><FaTruck className="nav-icon" /> Provider</Nav.Link>
            <Nav.Link as={Link} to="/routing-guide"><FaBook className="nav-icon" /> Routing Guide</Nav.Link>
            <Nav.Link as={Link} to="/rules"><FaBook className="nav-icon" /> Rules</Nav.Link>
            {/* <Nav.Link as={Link} to="/reports"><FaChartBar className="nav-icon" /> Reports</Nav.Link> */}
            {isAuthenticated && hasManageUsersPermission && (
              <Nav.Link as={Link} to="/users"><FaUsers className="nav-icon" /> Users</Nav.Link>
            )}
            {isAuthenticated && (
              <NavDropdown title={<FaUser className="user-icon" />} id="basic-nav-dropdown" alignRight>
                <NavDropdown.Item as={Link} to="/user-settings"><FaCog className="dropdown-icon" /> Settings</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/signout"><FaSignOutAlt className="dropdown-icon" /> Sign Out</NavDropdown.Item>
              </NavDropdown>
            )}
            {!isAuthenticated && <Nav.Link as={Link} to="/signin"><FaSignInAlt className="nav-icon" /> Sign In</Nav.Link>}
          </Nav>
        </Navbar.Collapse>
      </div>
    </Navbar>
  );
};

export default NavBar;
